import React from 'react'
import { withStyles } from '@material-ui/styles'
import { connect } from 'react-redux'
import { store } from '@redux/store'
import { ACTION_TYPE as AUTH_ACTION_TYPE, login } from '@redux/reducers/auth'
import { ACTION_TYPE as DATA_SERVICE_ACTION_TYPE, init } from '@redux/reducers/data-service'

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        dataService: state.dataService,
    }
}

const mapDispatchToProps = (dispatch) => ({
    authInit: () => dispatch({ type: AUTH_ACTION_TYPE.INIT }),
    authLogin: ({account, password, otp}) => {
        return dispatch({
            type: AUTH_ACTION_TYPE.LOGIN,
            payload: login(account, password, otp),
        })
    },
    authLogout: () => {
        // TODO: need group up the actions below, also called from utils/api.js when error code is (res.data.code === 16001 || res.data.code === 16002)
        dispatch({ type: AUTH_ACTION_TYPE.LOGOUT })
        dispatch({ type: DATA_SERVICE_ACTION_TYPE.CLEAR })
    },
    dataServiceInit: (promiseResolve) =>
        dispatch({
            type: DATA_SERVICE_ACTION_TYPE.INIT,
            payload: init(store.getState().auth),
            promiseResolve: promiseResolve,
        }),
    completeDecimal: (bool) => {
        dispatch({
            type: AUTH_ACTION_TYPE.COMPLETEDECIMAL,
            payload: bool,
        })
    },
    otpBindingSuccess: () => {
        dispatch({
            type: AUTH_ACTION_TYPE.OTPBINDINGSUCESS
        })
    }
})

export default (styles) => (WrappedComponent) => {
    class StandardHOC extends React.Component {
        // eslint-disable-next-line  no-useless-constructor
        constructor(props) {
            super(props)
        }

        render() {
            return <WrappedComponent {...this.props} />
        }
    }

    StandardHOC.propTypes = {}

    return connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StandardHOC))
}
